import { render, staticRenderFns } from "./UsersTableSkeleton.vue?vue&type=template&id=55250673&scoped=true&"
import script from "./UsersTableSkeleton.vue?vue&type=script&lang=ts&"
export * from "./UsersTableSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55250673",
  null
  
)

export default component.exports